module.exports = __webpack_public_path__ + "img/e6.bda2d077.jpg";